import { Box, styled } from '@mui/material';
import Button from '@mui/material/Button';

export const StyledFormBox = styled(Box)`
    background-color: white;
`;

export const StyledFormButton = styled(Button)`
    text-align: center;
    color: black;
`;
